import { Project } from '@material-bank/projects-api';
import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './analytics';
import { ProductSearchMaterial } from '../../types';

export const mapMaterialsForAnalytics = (
  data: ProductSearchMaterial[] = [],
  currentColor: string | null,
  itemListId: string,
  itemListName: string,
  project?: Project | null,
) => {
  const configLang =
    typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;
  const currency = configLang === 'EU' ? 'EUR' : 'USD';

  const gaType = data?.map((item, index) => {
    const colorway = item.colorVariants?.items?.find(
      (color) => color.image_url === item.thumbnailImageUrl?.split('?')?.[0],
    );
    let itemColor = null;
    if (colorway != null) {
      itemColor = colorway?.exact_color;
    }
    const finishesColor = item?.configData?.color;
    const isDigital = item?.isDigital || item?.originalMaterial?.isDigital;

    const finalObj: {
      item_id: string;
      item_name: string;
      item_brand: string;
      item_type: ReturnType<typeof getAnalyticsItemType>;
      item_category: string;
      item_category2: string;
      item_category3: string;
      item_category4: string;
      item_category5: string;
      item_manufacturer_sample_id: string;
      family_sku: string;
      index: number;
      price: number;
      quantity: number;
      item_list_id: string;
      item_list_name: string;
      item_variant: string;
      associated_item?: string;
    } = {
      item_id: item.sku || '',
      item_name: item.name,
      item_brand: item.manufacturer || '',
      item_type: getAnalyticsItemType(item),
      ...getAnalyticsItemCategoriesByTaxonomy(item.taxonomy ?? []),
      item_category4: item.industrySector?.join(', ') || '',
      // Provide the bag project type on add_to_cart events, current project type label otherwise
      item_category5: project?.type?.label || '',
      item_manufacturer_sample_id: item.manufacturerSampleId || '',
      family_sku: item.familySku || '',
      index: item.gridIndex || index + 1,
      price: 0,
      quantity: 1,
      item_list_id: isDigital ? 'digital_sampling' : itemListId,
      item_list_name: isDigital ? 'digital sampling' : itemListName,
      item_variant: finishesColor || currentColor || itemColor || '',
    };

    if (item.associatedItem != null) {
      finalObj['associated_item'] = item.associatedItem || '';
    }

    return finalObj;
  });

  return { gaType, currency };
};
